import { SAVE_SETTINGS_MACHINES } from '../../actions/actionTypes';

export const machinesConfig = (state, action) => {
  const initState = {
    isPending: true,
    allIds: [],
    byId: {},
  };

  switch (action.type) {
    case SAVE_SETTINGS_MACHINES:
      return {
        ...state,
        isPending: false,
        byId: action.payload.settingsMachines.entities.settingsMachines,
        allIds: action.payload.settingsMachines.result,
      };
    default:
      return state || initState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/settings/machines.js